import "./AboutKropsCapital.css";



function AboutKropsCapital() {
  return (
    <div className="about">

      <h1>About KROPS CAPITAL</h1>

      <section className="about-section">
        <p>
          <strong>Krops Capital</strong> is a multi-asset financial services entity.
          Our philosophy is to manage and grow your wealth with trust and expertise.
        </p>

        <p>
          We leverage decades of experience in financial services to develop the
          right insights, manage risks, and maximize returns sensibly, efficiently,
          and with integrity.
        </p>
      </section>

      <section className="about-section">
        <h2>Our Foundation</h2>
        <p>
          Krops Capital was founded by senior ex-bankers to provide a professional
          platform offering multi-asset financial advisory services in India.
        </p>

        <p>
          Established in 2001, we began as a multi-asset financial advisory and
          private wealth management practice.
        </p>
      </section>

      <section className="about-section">
        <h2>Our Growth</h2>
        <p>
          We believe in operating with agility and delivering hands-on expertise
          focused on the long-term financial well-being of our clients.
        </p>

        <p>
          Over the years, we have grown rapidly and today serve clients not only
          in India, but also across the Middle East, South East Asia, the UK, and Japan.
        </p>
      </section>

      <section className="about-highlight">
        <p>
          At <strong>Krops Capital</strong>, we understand that your needs are unique
          and your choices are many.
        </p>

        <p>
          Making the right choices at the right time — aligned with your financial
          goals — is key.
        </p>

        <p>
          We act as your trusted advisor, helping you navigate the complexities of
          wealth creation and preservation in a holistic and disciplined manner.
        </p>
      </section>

    </div>
  );
}

export default AboutKropsCapital;
